import { createRoutine } from "redux-saga-routines";

export const getInternalStreamsRoutine = createRoutine('GET_INTERNAL_STREAMS_ROUTINE');
export const addInternalStreamRoutine = createRoutine('ADD_INTERNAL_STREAM_ROUTINE');
export const updateInternalStreamRoutine = createRoutine('UPDATE_INTERNAL_STREAM_ROUTINE');
export const deleteInternalStreamRoutine = createRoutine('DELETE_INTERNAL_STREAM_ROUTINE');
